import React, {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import i18next from 'i18next';

import {appActions, simulatorActions} from '../../store';

import {
    Dialog,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Slide,
    Button,
    List,
    ListItem,
    ListItemText,
    DialogTitle,
    Switch,
    DialogContent,
    FormControlLabel,
    Radio,
    RadioGroup, DialogActions
} from '@mui/material';
import {Close as CloseIcon} from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const languageMap = {
    en: {label: 'English', dir: 'ltr', active: true},
    de: {label: 'Deutsch', dir: 'ltr', active: false},
};

export const Settings = () => {
    const settingsOpen = useSelector(state => state.app.settingsOpen);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const selectedLanguageBase = localStorage.getItem('i18nextLng') || 'en';
    const antiWindupEnableBase = useSelector(state => state.simulator.antiWindup);
    const returnYNegativeBase = useSelector(state => state.simulator.returnYNegative);

    const [selectedLanguage, setSelectedLanguage] = useState(selectedLanguageBase);
    const [antiWindupEnable, setAntiWindupEnable] = useState(antiWindupEnableBase);
    const [returnYNegativeEnable, setReturnYNegativeEnable] = useState(returnYNegativeBase);

    const [activeSelect, setActiveSelect] = useState(undefined);
    const [selectedItem, setSelectedItem] = useState(undefined);

    const discardSettings = () => {
        setSelectedLanguage(selectedLanguageBase);
        setAntiWindupEnable(antiWindupEnableBase);
        setReturnYNegativeEnable(returnYNegativeBase);
        dispatch(appActions.closeSettings());
    };

    const saveSettings = () => {
        i18next.changeLanguage(selectedLanguage);
        dispatch(simulatorActions.setAntiWindup(antiWindupEnable));
        dispatch(simulatorActions.setReturnYNegative(returnYNegativeEnable));
        dispatch(appActions.closeSettings());
    };

    return (
        <Dialog
            open={settingsOpen}
            onClose={discardSettings}
            fullWidth
            maxWidth={'xs'}
            TransitionComponent={Transition}
        >
            <AppBar position="sticky">
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={discardSettings}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <Typography variant="h6" flexGrow={1}>
                        {t('settings')}
                    </Typography>
                    <Button autoFocus color="inherit" onClick={saveSettings}>
                        {t('save')}
                    </Button>
                </Toolbar>
            </AppBar>
            <List>
                <ListItem button onClick={() => setActiveSelect({title: t('language'), options: languageMap, selectedValue: selectedLanguage, onSave: setSelectedLanguage})}>
                    <ListItemText primary={t('language')} secondary={languageMap[selectedLanguage].label}/>
                </ListItem>
                <ListItem>
                    <ListItemText primary={t('anti_windup')}/>
                    <Switch edge="end" checked={antiWindupEnable}
                            onChange={(event) => setAntiWindupEnable(event.target.checked)}/>
                </ListItem>
                <ListItem>
                    <ListItemText primary={t('return_y_negative')}/>
                    <Switch edge="end" checked={returnYNegativeEnable}
                            onChange={(event) => setReturnYNegativeEnable(event.target.checked)}/>
                </ListItem>
            </List>
            <Dialog
                open={activeSelect !== undefined}
                onClose={() => {
                    setSelectedItem(undefined);
                    setActiveSelect(undefined);
                }}
                fullWidth
                maxWidth={'xs'}
            >
                <DialogTitle>{activeSelect?.title}</DialogTitle>
                <DialogContent dividers>
                    <RadioGroup
                        defaultValue={activeSelect?.selectedValue}
                        onChange={(event) => {
                            setSelectedItem(event.target.value);
                        }}
                    >
                        {Object.keys(activeSelect?.options ?? {}).map((option) => (
                            <FormControlLabel
                                value={option}
                                key={option}
                                control={<Radio/>}
                                label={activeSelect?.options[option].label}
                            />
                        ))}
                    </RadioGroup>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => {
                        setSelectedItem(undefined);
                        setActiveSelect(undefined);
                    }}>
                        {t('cancel')}
                    </Button>
                    <Button onClick={() => {
                        activeSelect?.onSave(selectedItem ?? activeSelect.selectedValue);
                        setActiveSelect(undefined);
                    }}>{t('save')}</Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
};